export interface IQuyTrinhXuLyThietBi{
    Id:number,
    IdThietBi:number,
    Ten:string,
    NoiDungXuLy:string,
    TrangThai:number,
    IdCoQuan:number,
    TrangThaiApDung:number,
    IdNhom:number,
    TenNhom:string,
    NangCap:number
}
export class QuyTrinhXuLyThietBi implements IQuyTrinhXuLyThietBi{
    Id:number = 0;
    IdThietBi:number=0;
    Ten:string='';
    NoiDungXuLy:string = '';
    TrangThai:number=1;
    IdCoQuan:number=0;
    TrangThaiApDung:number=0;
    IdNhom:number = 0;
    TenNhom:string="";
    NangCap:number;
}


// WEBPACK FOOTER //
// D:/1.eGovD/CITIZEN/sources/citizen-admin/Angular/src/app/quy-trinh-xu-ly-thiet-bi/quy-trinh-xu-ly-thiet-bi.ts